import { useState, useCallback } from 'react';
import { GalleryPanelEnum, GALLERY_DATA_PANEL_ID } from '../settings';
export const useGallery = _ref => {
  let {
    defaultActivePanel = -1,
    isBasicEditingMode,
    onOpenAdvancedDataEditor,
    onOpenUpload,
    onSignup
  } = _ref;
  const {
    0: activeGalleryPanel,
    1: setActiveGalleryPanel
  } = useState(defaultActivePanel); // Handle custom menu item actions

  const selectGalleryItem = useCallback(updatePanelId => {
    setActiveGalleryPanel(updatePanelId);
    if (updatePanelId < 0) return; // Mangage side-effects of open gallery panels

    if (!isBasicEditingMode && updatePanelId === GALLERY_DATA_PANEL_ID && typeof onOpenAdvancedDataEditor === 'function') {
      onOpenAdvancedDataEditor();
      return;
    }

    if (updatePanelId === GalleryPanelEnum.UPLOAD && typeof onOpenUpload === 'function') {
      onOpenUpload();
      return;
    }

    if (updatePanelId === GalleryPanelEnum.SIGNUP && typeof onSignup === 'function') {
      onSignup();
      return;
    }
  }, [isBasicEditingMode, onOpenUpload, onOpenAdvancedDataEditor, onSignup]);
  const closeGalleryPanel = useCallback(() => {
    setActiveGalleryPanel(-1);
  }, []);
  return {
    activeGalleryPanel,
    selectGalleryItem,
    closeGalleryPanel
  };
};